




























import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'

import { AuthMixin } from '@/components/authMixin'
import Breadcrumb from '@/components/Breadcrumb.vue'
import Footer from '@/components/Footer.vue'
import LeftMenu from '@/components/LeftMenu.vue'
import TopMenu from '@/components/TopMenu.vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import Loading from '../components/Loading.vue'
// import { getConstants, getFilteredMenuData } from '../service/common'
import { getFilteredMenuData } from '../service/common'
import {
  BUSSINESS,
  BUSSINESS_SUBJECTS,
  SENSITIVE_WORDS,
  SUBJECTS,
  USER_GROUPS
} from '../service/constant'
import { getUrlParams } from '../utils/urlUtils'
import store from './store'

@Component({
  components: { Footer, TopMenu, Breadcrumb, LeftMenu, Loading }
})
export default class App extends Mixins(AuthMixin) {
  public localeZHCN = zhCN

  private get hasMenus() {
    return getFilteredMenuData(this.$store.state[USER_GROUPS]).length > 0
  }

  public created() {
    this.tryLogin()
    this.registerLoginInfoSync()

    let ticket = getUrlParams().ticket
    if (ticket) return // block所有网络请求
    if (!this.$store.state[USER_GROUPS] || this.$store.state[USER_GROUPS].length == 0) return // 无效账户stop

    // getConstants().then((retData) => {
    //   if (retData.success) {
    //     const dict = retData.data.sensitive_type_data
    //     const data = Object.keys(dict).map((key) => ({ value: +key, label: dict[key] }))

    //     const dict2 = retData.data.subject_data
    //     const subjects = Object.keys(dict2).map((key) => ({ value: +key, label: dict2[key] }))

    //     const dict3 = retData.data.business_type_data
    //     const bizs = Object.keys(dict3).map((key) => ({ value: +key, label: dict3[key] }))

    //     const dict4 = retData.data[BUSSINESS_SUBJECTS]
    //     const biz_obj_dict = {}
    //     Object.keys(dict4).forEach((key) => {
    //       let temp = Object.assign({}, ...dict4[key])
    //       biz_obj_dict[key] = Object.keys(temp).map((sub) => ({ value: +sub, label: temp[sub] }))
    //     })

    //     store.commit('setConstants', {
    //       [SENSITIVE_WORDS]: data,
    //       [SUBJECTS]: subjects,
    //       [BUSSINESS]: bizs,
    //       [BUSSINESS_SUBJECTS]: biz_obj_dict
    //     })
    //   }
    // })
  }
}
